import axios from 'axios';

export class Authentication {
    private apiKey: string | null = null;

    constructor() {
        this.load();
        this.checkForNewApiKey();
    }

    public listen(): void {
        window.emitter.on('logout', () => this.clearApiKey());
        window.emitter.on('api_returned_401', () => this.clearApiKey());
    }

    public setApiKey(apiKey: string): void {
        this.apiKey = apiKey;
        window.localStorage.setItem('onlinetennis.api_key', this.apiKey);
        this.updateAxios();
    }

    public clearApiKey(): void {
        this.apiKey = null;
        window.localStorage.removeItem('onlinetennis.api_key');
    }

    public getApiKey(): string | null {
        return this.apiKey;
    }

    public updateAxios(): void {
        if (this.isAuthenticated()) {
            axios.defaults.headers.common['X-Auth-Token'] = `Bearer ${this.apiKey}`;
            axios.defaults.headers.common['X-Platform'] = navigator.userAgent;
        }
    }

    public isAuthenticated(): boolean {
        this.load();
        return this.apiKey !== null;
    }

    private load(): void {
        const apiKey = window.localStorage.getItem('onlinetennis.api_key');
        if (apiKey !== null) {
            this.apiKey = apiKey;
        }
    }

    private checkForNewApiKey(): void {
        if (typeof generatedApiKey === 'undefined') {
            return;
        }

        this.setApiKey(generatedApiKey);
    }
}

const authentication = new Authentication();

export default authentication;
